import Effects from "./Effects";

function Home() {
    return (
         <section id="home" className="home">
            <Effects />
            <div className="home-content">
                <h1>
                    <span className="highlight">SHREYEZZ</span>
                </h1>
                <h3>
                    VFX Artist
                </h3>
            </div>
        </section>
    );
}

export default Home;